import PropTypes from 'prop-types';
import React from 'react';
import { Carousel, Image, Modal } from 'react-bootstrap';
import DraftRenderer from '../../../components/DraftRenderer/DraftRenderer';
import PropertyDescriptionForm from './PropertyDescriptionForm';
import { Button } from 'react-bootstrap';
import RoomsPhotosForm from './RoomsPhotosForm';
import noimage1 from '../../../../public/noimage1.jpg'


function hasPhotos(photos) {
  if (!photos) {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(photos, 'length')) {
    return photos.length !== 0;
  }
  return false;
}


function formatCarouselPhotos(photos) {
  const photoList = [];
  if (hasPhotos(photos)) {
    photos.forEach(photo => {
      photoList.push(
        <Carousel.Item key={photo.id}>
          {photo.photo ?
            <Image src={photo.photo} responsive className="hotel-img" />
            :
            <Image src={noimage1} responsive className="hotel-img" />
          }
        </Carousel.Item>
      );
    });
  } else {
    photoList.push(
      <Carousel.Item key={1}>
        <Image src={noimage1} responsive className="hotel-img" />
      </Carousel.Item>
    );
  }
  return photoList
}

class RoomPhotosModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.editimage = this.editimage.bind(this);
    this.handlegetPhoto = this.handlegetPhoto.bind(this);
    if(this.props.isHotelView){
      this.state = { show: false, isEditing: false,isRoomtypeView:this.props.isRoomtypeView };
    }else{
      this.state = { show: false, isEditing: true,isRoomtypeView:this.props.isRoomtypeView };
    }
    
  }

  editimage() {
    this.setState({ isImageEdit: false })
  }
  handleClose() {
    this.setState({ isEditing: false }, () => {
      this.props.closeModal()
    });
  }
  handleEdit() {

    this.setState({ isEditing: true,isRoomtypeView:false });
  }
  handleCancelEdit() {
    //this.setState({ isEditing: false,isRoomtypeView:true });
    this.setState({ isEditing: false,isRoomtypeView:true }, () => {
      this.props.closeModal()
    });
  }
  handleShow(idx) {
    this.setState({ show: true, idx });
  }

  handleSubmit(values) {
    const payload = { ...this.props.roomType }
    payload.description = values
    this.props.editRoomtypes(this.props.roomType.id, payload);
    this.handleClose();
  }
  handlegetPhoto(values) {
    this.props.addAddHotelRoomPhoto(values)
  }

  render() {
    const photos = formatCarouselPhotos(this.props.roomType.room_photos);
    return (
      <div>
        <Modal
          show={this.props.show}
          onHide={this.handleClose}
          dialogClassName="room-photos-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Room Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ width: '550px', float: "left", margintop: "-4px" }}>
              {this.state.isEditing && !this.state.isRoomtypeView &&
                <RoomsPhotosForm
                  {...this.props}
                  handleClose={this.handleClose}
                  handlegetPhoto={this.handlegetPhoto}
                  isRoomForms={true}
                  removeRoomPhoto={this.props.removeRoomPhoto}
                  editHotelPhoto={this.props.editHotelPhoto}
                />
              }
              {this.state.isRoomtypeView &&
                <div><Carousel
                  indicators={true}
                  interval={null}
                  prevIcon={<i className="fa fa-chevron-left hotel-carousel-control left" />}
                  nextIcon={<i className="fa fa-chevron-right hotel-carousel-control right" />}
                  onSelect={this.editimage}
                >
                  {photos}
                </Carousel>
                </div>
              }
            </div>
            <div style={{ width: '400px', float: "left", marginLeft: '38px' }}>
              {this.state.isRoomtypeView && <div className="col-md-12 hotel-details-description">
                <h4 className="hotel-highlight">
                  Room Description&nbsp;{!this.props.isHotelView && <Button onClick={this.handleEdit}>Edit</Button>}
                </h4>
                <DraftRenderer raw={this.props.roomType.description} placeholder="No property description." />
              </div>}
              {this.state.isEditing &&  !this.state.isRoomtypeView &&
                <PropertyDescriptionForm
                  {...this.props}
                  onSubmit={this.handleSubmit}
                  content={this.props.roomType.description}
                  isRoomDetails={true}
                  handleCancelEdit={this.handleCancelEdit}
                />
              }
            </div>
            <div className="row"></div>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
      </div>
    );
  }
}
export default RoomPhotosModal;



// WEBPACK FOOTER //
// src/routes/hotels/components/RoomPhotosModal.js